import { useState } from 'react';
import config from '../../utils/apiUrl';
import useEpaycoToken from './useTokenEpayco';

const useEpaycoPseTransaction = () => {
  const { getTokenApify } = useEpaycoToken();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [transactionData, setTransactionData] = useState(null);

  const processTransaction = async (paymentData) => {
    setLoading(true);
    setError(null);

    try {
      const tokenApify = await getTokenApify();
      // Get the current URL to use as the redirect URL
      const currentUrl = window.location.href;
      // Add a query parameter to indicate this is a return from PSE
      const redirectUrl = new URL(currentUrl);
      redirectUrl.searchParams.set('pse_return', 'true');
      redirectUrl.searchParams.set('ref', Date.now());
      const requestBody = {
        value: String(paymentData.amount),
        bank: paymentData.financialInstitution,
        docType: paymentData.documentType,
        docNumber: paymentData.documentNumber,
        name: paymentData.firstName + ' ' + paymentData.lastName,
        email: paymentData.email,
        cellPhone: paymentData.phone,
        phone: paymentData.phone,
        currency: 'COP',
        bill: paymentData.bill || 'OR-1234',
        tax: paymentData.tax || 0,
        tax_base: paymentData.tax_base || '0',
        extra1: paymentData.extra1 || '',
        extra2: paymentData.extra2 || '',
        testMode: paymentData.testMode || false,
        ip: paymentData.ip || '127.0.0.1',
        urlResponse: redirectUrl.toString(),
        company: paymentData.company || true,
        urlConfirmation: `${config.epayco.redirectBaseUrl}/payments/transaction/events/epayco`,
      };
      console.log('Sending PSE request with body:', requestBody);
      const response = await fetch(
        `${config.epayco.apiUrl}/payment/process/pse`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${tokenApify}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        }
      );
      const data = await response.json();
      console.log('PSE API response:', data);
      if (!response.ok || !data.success) {
        const errorMessage =
          data?.message || 'Error al procesar la transacción PSE';
        throw new Error(errorMessage);
      }

      if (data?.data?.urlbanco) {
        console.log('Attempting to open URL:', data.data.urlbanco);
        window.open(data.data.urlbanco, '_blank', 'noopener,noreferrer');
      } else {
        throw new Error(
          'No se pudo obtener la URL del banco para la transacción.'
        );
      }

      setTransactionData(data);
      return data;
    } catch (err) {
      console.error('Error durante la transacción PSE:', err.message);
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { processTransaction, loading, error, transactionData };
};

export default useEpaycoPseTransaction;
